/**
 * Product Services Selector (M1 - fork feature/servizi-pdp)
 *
 * Consuma la stessa API della scheda (proxy, type=product_shipping_info_box),
 * chiamata async DOPO il load, e trasforma l'HTML in una selezione interattiva
 * on-brand di consegna al piano + servizi (installazione, ritiro usato, inversione porte).
 *
 * Al piano = prezzo dall'API (somma dei 2 costi lato backend, non replicata qui).
 * Charging NON attivo (M2): qui solo presentazione + selezione + totale.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-services-selector]');
  if (!root || root.getAttribute('data-loaded') === 'true') return;

  // Varianti del prodotto "Servizi Yeppon" (prezzo 0, il prezzo esatto lo mette la Cart Transform)
  var SVC_STORE = window.__svcVariants || {};
  var SERVICE_VARIANTS = SVC_STORE.INST ? SVC_STORE : {
    INST: '65719443194205', // Installazione
    RAEE: '65719443226973', // Ritiro usato
    GPO: '65719443259741',  // Inversione porte
    INC: '65773405274461',  // Incasso
    KC: '65783243342173'    // Installazione a colonna (gratis, solo con INST)
  };
  // Consegna al piano: la TARIFFA resta lato spedizione (delivery function). Con la
  // scelta attiva aggiungiamo pero' questa variante a 0,00 come RIGA-MARCATORE:
  // e' l'unico segnale robusto (sopravvive a login/merge, visibile alle checkout
  // UI extension via merchandise id; property _ e cart attribute non bastano).
  var ALP_MARKER_VARIANT = SVC_STORE.ALP || '65719443161437';
  // fetch NATIVA per le nostre scritture carrello: il popup garanzia patcha window.fetch
  // e dirotta gli add a singolo item verso il popup (invece di aggiungere)
  var svcFetch = (window.__warrantyOrigFetch || window.fetch).bind(window);
  function codeForName(name) {
    var n = (name || '').toLowerCase();
    // "colonna" PRIMA di "installazione": "Installazione a colonna" contiene entrambe
    if (n.indexOf('colonna') !== -1) return 'KC';
    if (n.indexOf('installazione') !== -1) return 'INST';
    if (n.indexOf('ritiro') !== -1) return 'RAEE';
    if (n.indexOf('inversione') !== -1) return 'GPO';
    if (n.indexOf('incasso') !== -1) return 'INC';
    return null;
  }

  // CAP per il prezzo esatto della consegna al piano (fase 2, param zipCode dell'API)
  // Sede Yeppon, Paderno Dugnano (MI): stesso listino di Milano se non c'è una zona scelta
  var DEFAULT_MILAN_ZIP = '20037';
  function getCap() {
    try {
      var z = localStorage.getItem('yp_svc_cap') || '';
      return /^\d{5}$/.test(z) && z !== '00000' ? z : '';
    } catch (e) { return ''; }
  }
  function setCap(z) { try { localStorage.setItem('yp_svc_cap', z || ''); } catch (e) {} }

  var loadingEl = root.querySelector('[data-svc-loading]');
  var contentEl = root.querySelector('[data-svc-content]');
  var apiUrl = (root.getAttribute('data-api-url') || '').replace(/\/$/, '');
  var productGid = root.getAttribute('data-product-gid') || '';
  var customerGid = root.getAttribute('data-customer-gid') || '';
  // cliente loggato con indirizzo: il CAP di default arriva dal tema (Liquid)
  var customerZip = (root.getAttribute('data-customer-zip') || '').trim();
  if (!/^\d{5}$/.test(customerZip) || customerZip === '00000') customerZip = '';
  var customerLabel = (root.getAttribute('data-customer-label') || '').trim();
  // TV e forni: consegna al piano NON preselezionata (scelta attiva dell'utente)
  var cat3 = root.getAttribute('data-cat3') || '';
  var ALP_DEFAULT_ON = !/(^|\s)tv(\s|$)|forn/i.test(cat3);

  // spunta in puro CSS (::after nel liquid): nessun svg da farsi ridipingere dal tema
  var CHECK_SVG = '';

  function done() { root.setAttribute('data-loaded', 'true'); }
  function hide() { root.setAttribute('hidden', ''); if (loadingEl) loadingEl.remove(); done(); }

  // "1.234,56" | "54,99" | "5,00" -> Number
  function parseEuro(text) {
    if (!text) return null;
    if (/gratis/i.test(text)) return 0;
    var m = text.replace(/\s/g, '').match(/([\d.]*\d(?:,\d{1,2})?)/);
    if (!m) return null;
    var n = parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
    return isNaN(n) ? null : n;
  }
  function fmtEuro(n) {
    if (n === 0) return 'Gratis';
    return n.toFixed(2).replace('.', ',') + ' €';
  }
  function clean(text) {
    return (text || '').replace(/\s+/g, ' ').replace(/\*+/g, '').trim();
  }
  // per alcune zone l'API accoda al nome dell'opzione "– Spedizione a <luogo>, CAP <cap>":
  // in scheda il CAP sta gia' nella nota zona, il suffisso confonde (resta il CAP vecchio)
  function cleanAlpName(name) {
    return (name || '').replace(/\s*[–—-]\s*Spedizione a.*$/i, '').trim();
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // tariffe che cambiano per zona: al piano e corriere specializzato/appuntamento
  var ZONAL_PATTERN = /piano|specializzato|appuntamento/i;

  function parse(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var heads = Array.prototype.slice.call(doc.querySelectorAll('h5'));
    if (!heads.length) return null;

    // 1) Consegna al piano = primo h5
    var alpH = heads[0];
    var alpSpans = alpH.querySelectorAll('span');
    var alp = {
      name: clean(alpSpans[0] ? alpSpans[0].textContent : alpH.textContent),
      price: parseEuro(alpSpans[1] ? alpSpans[1].textContent : ''),
      included: [],
      addons: []
    };

    // ul piu' vicino dopo il primo h5
    var ul = null, walker = alpH;
    while (walker && !ul) {
      if (walker.nextElementSibling && walker.nextElementSibling.tagName === 'UL') { ul = walker.nextElementSibling; break; }
      walker = walker.parentElement;
      if (walker) ul = walker.querySelector('ul');
    }
    if (ul) {
      Array.prototype.slice.call(ul.querySelectorAll('li')).forEach(function (li) {
        var raw = li.textContent || '';
        var price = null;
        var pm = raw.match(/\(\s*\+?\s*€\s*[\d.,]+\s*\)/);
        if (pm) price = parseEuro(pm[0]);
        else if (/\(\s*gratis\s*\)/i.test(raw)) price = 0;

        var base = raw.replace(/\(\s*\+?\s*€\s*[\d.,]+\s*\)/i, '').replace(/\(\s*gratis\s*\)/i, '');
        var name = clean(base.split('(')[0]);
        var qualMatch = base.match(/\(([^)]+)\)/);
        var qualifier = qualMatch ? clean(qualMatch[1]) : '';

        if (price === null) {
          if (name) alp.included.push(name);           // feature inclusa (contatto tel., disimballo)
        } else {
          alp.addons.push({ name: name, price: price, qualifier: qualifier });
        }
      });
    }

    // 2) alternative = h5 successivi
    var alts = heads.slice(1).map(function (h) {
      var sp = h.querySelectorAll('span');
      return { name: clean(sp[0] ? sp[0].textContent : h.textContent), price: parseEuro(sp[1] ? sp[1].textContent : '') };
    });

    // 3) note (* indicativo Milano, ecc.)
    var notes = Array.prototype.slice.call(doc.querySelectorAll('.info-box-msg')).map(function (n) { return clean(n.textContent); }).filter(Boolean);

    return { alp: alp, alts: alts, notes: notes };
  }

  // Campi strutturati dell'API (post #368): dove ci sono vincono sull'html.
  // Contratto: al piano = shippingList id 39 (mai match sul nome), codici servizio stabili.
  var ALP_SHIPPING_ID = 39;
  function applyStructured(data, d) {
    if (d && Object.prototype.toString.call(d.shippingList) === '[object Array]' && d.shippingList.length) {
      var alpOpt = null, alts = [];
      d.shippingList.forEach(function (o) {
        if (o.id === ALP_SHIPPING_ID) alpOpt = o;
        else alts.push({ name: o.name, price: o.price });
      });
      if (alpOpt) {
        data.alp.name = alpOpt.name;
        data.alp.price = alpOpt.price;
        data.alts = alts;
      }
      data.shippingList = d.shippingList;
    }
    if (d && Object.prototype.toString.call(d.serviceList) === '[object Array]' && d.serviceList.length && data.alp) {
      var htmlAddons = data.alp.addons || [];
      data.alp.addons = d.serviceList.map(function (s) {
        var q = '';
        htmlAddons.forEach(function (h) { if (h.name === s.name && h.qualifier) q = h.qualifier; });
        return { name: s.name, price: s.price, qualifier: q, code: s.code };
      });
    }
    data.zip = d && d.inputZipCode ? String(d.inputZipCode) : '';
    return data;
  }

  // Dialog "Scegli la tua zona di consegna": singleton condiviso tra la modalita'
  // selettore (al piano) e quella informativa (corriere specializzato zonale)
  var zoneDlg = (function () {
    var el = null, input, err, ok, okText, doneBtn, pending, pendingData;
    var getZip = function () { return ''; };
    var onCommit = function () {};
    function close() { if (el) el.hidden = true; }
    function previewTarget(d2) {
      var list = d2 && d2.shippingList;
      if (list && list.length) {
        var byId = null, byName = null;
        list.forEach(function (o) {
          if (o.id === ALP_SHIPPING_ID && !byId) byId = o;
          if (!byName && ZONAL_PATTERN.test(o.name || '')) byName = o;
        });
        var o = byId || byName || list[0];
        return { name: cleanAlpName(o.name) || o.name || '', price: o.price };
      }
      if (d2 && d2.html) {
        var t = parse(d2.html);
        if (t && t.alp && t.alp.price != null) return { name: cleanAlpName(t.alp.name), price: t.alp.price };
      }
      return null;
    }
    function previewZip(zip) {
      if (!/^\d{5}$/.test(zip) || zip === '00000') { err.hidden = false; ok.hidden = true; doneBtn.hidden = true; return; }
      err.hidden = true; doneBtn.hidden = true;
      okText.textContent = 'Verifico…';
      ok.hidden = false;
      fetchSvc(zip).then(function (d2) {
        var t = previewTarget(d2);
        if (!t || t.price == null) { err.hidden = false; ok.hidden = true; return; }
        pending = zip; pendingData = d2;
        okText.innerHTML = 'CAP <b>' + escapeHtml(zip) + '</b> &middot; ' + escapeHtml(t.name.slice(0, 34)) + ' <b>' + fmtEuro(t.price) + '</b>';
        doneBtn.hidden = false;
      }).catch(function () { err.hidden = false; ok.hidden = true; });
    }
    function build() {
      el = document.createElement('div');
      el.className = 'svc-dlg-ovl';
      el.hidden = true;
      el.innerHTML =
        '<div class="svc-dlg" role="dialog" aria-modal="true" aria-label="Scegli la tua zona di consegna">' +
          '<div class="svc-dlg__head"><b>Scegli la tua zona di consegna</b>' +
          '<button type="button" class="svc-dlg__x" aria-label="Chiudi">&times;</button></div>' +
          '<div class="svc-dlg__body">' +
            '<p class="svc-dlg__why">Il costo di alcune spedizioni dipende dalla zona di consegna. Il CAP serve solo a calcolare la spedizione.</p>' +
            (customerLabel && customerZip
              ? '<button type="button" class="svc-dlg__addr"><span class="svc-dlg__addr-name">' + escapeHtml(customerLabel) + '</span>' +
                '<span class="svc-dlg__addr-note">Dal tuo account</span></button>' +
                '<div class="svc-dlg__div">oppure inserisci un CAP</div>'
              : '') +
            '<div class="svc-dlg__zrow"><input inputmode="numeric" maxlength="5" placeholder="CAP (es. 20121)" aria-label="CAP">' +
            '<button type="button" class="svc-dlg__apply">Applica</button></div>' +
            '<p class="svc-dlg__err" hidden>Inserisci un CAP italiano di 5 cifre.</p>' +
            '<div class="svc-dlg__ok" hidden><span class="svc-dlg__ok-ic"></span><span data-ok-text></span></div>' +
            '<button type="button" class="svc-dlg__done" hidden>Fatto</button>' +
            '<p class="svc-dlg__keep">La tua zona resta salvata per le prossime visite.</p>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);
      input = el.querySelector('input');
      err = el.querySelector('.svc-dlg__err');
      ok = el.querySelector('.svc-dlg__ok');
      okText = el.querySelector('[data-ok-text]');
      doneBtn = el.querySelector('.svc-dlg__done');
      el.addEventListener('click', function (e) { if (e.target === el) close(); });
      el.querySelector('.svc-dlg__x').addEventListener('click', close);
      el.querySelector('.svc-dlg__apply').addEventListener('click', function () { previewZip(input.value.trim()); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); previewZip(input.value.trim()); } });
      var addrBtn = el.querySelector('.svc-dlg__addr');
      if (addrBtn) addrBtn.addEventListener('click', function () { input.value = customerZip; previewZip(customerZip); });
      doneBtn.addEventListener('click', function () {
        if (pending && pendingData) onCommit(pending, pendingData);
        close();
      });
    }
    return {
      open: function (g, c) {
        getZip = g || getZip;
        onCommit = c || onCommit;
        if (!el) build();
        pending = ''; pendingData = null;
        err.hidden = true; ok.hidden = true; doneBtn.hidden = true;
        input.value = getZip() || '';
        el.hidden = false;
        if (!(customerLabel && customerZip)) setTimeout(function () { input.focus(); }, 60);
      }
    };
  })();

  function row(opts) {
    var el = document.createElement(opts.locked ? 'div' : 'button');
    el.className = 'svc-row' + (opts.on ? ' is-on' : '') + (opts.locked ? ' is-locked' : '');
    if (!opts.locked) { el.type = 'button'; el.setAttribute('aria-pressed', opts.on ? 'true' : 'false'); }
    var incl = '';
    if (opts.included && opts.included.length) {
      incl = '<span class="svc-row__incl">Incluso: ' + opts.included.join(' &middot; ') + '</span>';
    }
    el.innerHTML =
      '<span class="svc-row__check">' + CHECK_SVG + '</span>' +
      '<span class="svc-row__main"><span class="svc-row__name">' + opts.name + '</span>' +
      (opts.desc ? '<span class="svc-row__desc">' + opts.desc + '</span>' : '') + incl + '</span>' +
      '<span class="svc-row__price">' + opts.priceLabel + '</span>';
    return el;
  }

  var ALP_PATTERN = /al piano/i;

  // Modalita' informativa: prodotto SENZA consegna al piano -> solo elenco spedizioni
  function renderInfo(data) {
    var wrap = document.createElement('div');
    var head = document.createElement('div');
    head.innerHTML = '<p class="svc-selector__title">Spedizione</p>';
    wrap.appendChild(head);
    var opts = [{ name: data.alp.name, price: data.alp.price }].concat(data.alts).filter(function (o) { return o.name; });
    opts.forEach(function (o) {
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;justify-content:space-between;gap:1rem;font-size:1.3rem;padding:0.45rem 0;';
      row.innerHTML = '<span>' + o.name + '</span><span style="font-weight:var(--font-body-weight-bolder);white-space:nowrap;">' + (o.price != null ? fmtEuro(o.price) : '') + '</span>';
      wrap.appendChild(row);
    });
    // zona anche qui, ma solo se tra le opzioni c'e' una tariffa zonale
    // (corrieri standard = prezzo nazionale, il CAP non li muove)
    var zonal = opts.some(function (o) { return ZONAL_PATTERN.test(o.name || ''); });
    if (zonal) {
      data.notes = data.notes.filter(function (n) { return !/milano/i.test(n); });
      var capBlock = document.createElement('div');
      capBlock.className = 'svc-cap';
      capBlock.innerHTML = data.zip
        ? 'Prezzi per il CAP <b>' + escapeHtml(data.zip) + '</b> &middot; <button type="button" class="svc-cap__link">Cambia zona</button>'
        : 'Prezzi indicativi per Milano. <button type="button" class="svc-cap__link">Scegli la tua zona per i prezzi esatti</button>';
      capBlock.querySelector('.svc-cap__link').addEventListener('click', function () {
        zoneDlg.open(
          function () { return data.zip || getCap() || customerZip || ''; },
          function (zip, d2) {
            setCap(zip);
            var p2 = parse(d2.html);
            if (p2) renderInfo(applyStructured(p2, d2));
          }
        );
      });
      wrap.appendChild(capBlock);
    }
    if (data.notes.length) {
      var note = document.createElement('p');
      note.className = 'svc-selector__note';
      note.innerHTML = data.notes.join('<br>');
      wrap.appendChild(note);
    }
    contentEl.innerHTML = '';
    contentEl.appendChild(wrap);
    contentEl.hidden = false;
    if (loadingEl) loadingEl.remove();
    root.removeAttribute('hidden');
  }

  function render(data) {
    var alp = data.alp;
    if (!ALP_PATTERN.test(alp.name || '')) { renderInfo(data); return; }
    var wrap = document.createElement('div');

    var head = document.createElement('div');
    head.innerHTML =
      '<p class="svc-selector__title">Consegna e servizi</p>' +
      '<p class="svc-selector__sub">Scegli ora, li ritrovi gi&agrave; pronti al checkout.</p>';
    wrap.appendChild(head);

    var state = { alp: ALP_DEFAULT_ON, addons: {} };

    // riga consegna al piano (selezionabile, default ON)
    var alpRow = row({
      name: cleanAlpName(alp.name) || 'Consegna al piano',
      priceLabel: alp.price != null ? fmtEuro(alp.price) : '',
      included: alp.included,
      on: ALP_DEFAULT_ON
    });
    // la nota "indicativo per Milano" dell'html e' sostituita dal blocco zona (CAP)
    data.notes = data.notes.filter(function (n) { return !/milano/i.test(n); });
    alpRow.addEventListener('click', function () {
      state.alp = !state.alp;
      alpRow.classList.toggle('is-on', state.alp);
      alpRow.setAttribute('aria-pressed', state.alp ? 'true' : 'false');
      // se togli l'al piano, disattiva anche gli add-on (dipendono dal servizio)
      if (!state.alp) { Object.keys(state.addons).forEach(function (k) { state.addons[k] = false; }); syncAddons(); }
      updateTotal();
    });
    wrap.appendChild(alpRow);

    // --- Zona di consegna (fase 2 CAP): prezzo esatto via zipCode dell'API ---
    var capBlock = document.createElement('div');
    capBlock.className = 'svc-cap';
    wrap.appendChild(capBlock);
    var altEl = null; // riga "In alternativa", aggiornata al cambio zona
    function updateAlts() {
      if (!altEl) return;
      var validAlts = data.alts.filter(function (a) { return a.name; });
      altEl.hidden = !validAlts.length;
      altEl.innerHTML = '<b>In alternativa:</b> ' + validAlts.map(function (a) {
        return escapeHtml(a.name) + (a.price != null ? ' (' + fmtEuro(a.price) + ')' : '');
      }).join(' &middot; ');
    }
    function renderCapNote(fromAccount) {
      var zip = data.zip || '';
      capBlock.innerHTML = zip
        ? 'Prezzo per il CAP <b>' + escapeHtml(zip) + '</b>' + (fromAccount ? ' (dal tuo indirizzo)' : '') +
          ' &middot; <button type="button" class="svc-cap__link">Cambia zona</button>'
        : 'Prezzo indicativo per Milano. <button type="button" class="svc-cap__link">Scegli la tua zona per il prezzo esatto</button>';
      capBlock.querySelector('.svc-cap__link').addEventListener('click', openZone);
    }
    // applica una nuova zona: aggiorna prezzo al piano, alternative e nota (gli
    // add-on hanno prezzi uniformi nazionali e non cambiano)
    function commitZone(d2, zip) {
      var parsed = parse(d2.html);
      if (!parsed) return;
      var data2 = applyStructured(parsed, d2);
      if (data2.alp && data2.alp.price != null) {
        alp.price = data2.alp.price;
        if (data2.alp.name) alp.name = data2.alp.name;
        if (data2.alts && data2.alts.length) data.alts = data2.alts;
      }
      data.zip = data2.zip || zip;
      var priceEl = alpRow.querySelector('.svc-row__price');
      if (priceEl) priceEl.textContent = alp.price != null ? fmtEuro(alp.price) : '';
      var nameEl = alpRow.querySelector('.svc-row__name');
      if (nameEl) nameEl.textContent = cleanAlpName(alp.name) || 'Consegna al piano';
      updateTotal();
      updateAlts();
      renderCapNote(false);
    }
    function openZone() {
      zoneDlg.open(
        function () { return data.zip || getCap() || customerZip || ''; },
        function (zip, d2) { setCap(zip); commitZone(d2, zip); }
      );
    }
    renderCapNote(data.zipFromAccount === true);

    // add-on (installazione, ritiro usato, inversione porte, installazione a colonna)
    var addonRows = [];
    var instIdx = -1, kcIdx = -1;
    alp.addons.forEach(function (a, i) {
      var c = a.code || codeForName(a.name);
      if (c === 'INST') instIdx = i;
      if (c === 'KC') kcIdx = i;
    });
    alp.addons.forEach(function (a, i) {
      var desc = a.qualifier;
      // KC esiste solo insieme all'installazione classica (regola di listino)
      if (i === kcIdx && instIdx !== -1) desc = 'Disponibile solo con l’installazione';
      var r = row({ name: a.name, desc: desc, priceLabel: (a.price ? '+ ' : '') + fmtEuro(a.price), on: false });
      state.addons[i] = false;
      r.addEventListener('click', function () {
        if (!state.alp) return;
        if (i === kcIdx && instIdx !== -1 && !state.addons[instIdx] && !state.addons[i]) return; // KC solo con INST attiva
        state.addons[i] = !state.addons[i];
        // spegnendo l'installazione si spegne anche la colonna
        if (i === instIdx && !state.addons[i] && kcIdx !== -1) state.addons[kcIdx] = false;
        syncAddons();
        updateTotal();
      });
      addonRows.push({ el: r, idx: i });
      wrap.appendChild(r);
    });
    function syncAddons() {
      addonRows.forEach(function (x) {
        x.el.classList.toggle('is-on', state.addons[x.idx]);
        x.el.setAttribute('aria-pressed', state.addons[x.idx] ? 'true' : 'false');
        if (x.idx === kcIdx && instIdx !== -1) {
          var locked = !state.alp || !state.addons[instIdx];
          x.el.style.opacity = locked && !state.addons[x.idx] ? '0.45' : '';
        }
      });
    }
    syncAddons();

    // --- Aggiunta al carrello: i servizi selezionati diventano righe (prezzate lato server) ---
    function selectedServiceItems(qty, alpOn, addonsOn) {
      var items = [];
      if (alpOn === undefined) alpOn = state.alp;
      if (addonsOn === undefined) addonsOn = state.addons;
      if (!alpOn) return items;
      // riga-marcatore consegna al piano (0,00: la tariffa vera resta lato spedizione)
      items.push({
        id: ALP_MARKER_VARIANT,
        quantity: qty || 1,
        properties: {
          _svc_price: '0.00',
          _svc_code: 'ALP',
          _svc_label: 'Consegna al piano e disimballo',
          _parent: productGid
        }
      });
      alp.addons.forEach(function (a, i) {
        if (!addonsOn[i]) return;
        var code = a.code || codeForName(a.name);
        if (!code || !SERVICE_VARIANTS[code]) return;
        if (code === 'KC' && instIdx !== -1 && !addonsOn[instIdx]) return; // mai KC senza INST
        items.push({
          id: SERVICE_VARIANTS[code],
          quantity: qty || 1,
          properties: {
            _svc_price: (a.price || 0).toFixed(2),
            _svc_code: code,
            _svc_label: a.name,
            _parent: productGid
          }
        });
      });
      return items;
    }
    // catena condivisa: serializza tutte le scritture carrello dei nostri script
    function chainCart(fn) {
      window.__svcCartChain = (window.__svcCartChain || Promise.resolve()).then(fn).catch(function () {});
      return window.__svcCartChain;
    }
    // marcatore consegna al piano: attribute _alp_selected = lista gid prodotto
    // (letto al checkout dalla Function delivery-alp; potato da cart-services-sync)
    function updateAlpMarker(on) {
      return chainCart(function () {
        return svcFetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var cur = (cart.attributes && cart.attributes._alp_selected) || '';
            var gids = cur.split(',').filter(function (g) { return g && g !== productGid; });
            if (on) gids.push(productGid);
            var next = gids.join(',');
            if (next === cur) return;
            return svcFetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { _alp_selected: next } })
            });
          });
      });
    }

    // convivenza col popup garanzia (warranty-upsell): se ha preso lui il submit,
    // aspetto la chiusura del popup (accetta/rifiuta/Esc) e POI aggiungo i servizi
    var warrantyHooked = false;
    function proceedAfterWarranty(items) {
      if (warrantyHooked) return;
      warrantyHooked = true;
      var tries = 0;
      (function waitOverlay() {
        var overlay = document.querySelector('.wu-open');
        if (!overlay) {
          // popup non ancora aperto (o gia' chiuso): riprova per ~4s
          if (++tries < 40) return setTimeout(waitOverlay, 100);
          warrantyHooked = false;
          return;
        }
        (function waitClose() {
          if (overlay.classList.contains('wu-open')) return setTimeout(waitClose, 200);
          // popup chiuso: lascio partire l'add del warranty, poi aggiungo i servizi
          setTimeout(function () {
            svcSubmitting = true;
            var p = items.length
              ? svcFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
              : Promise.resolve();
            p.then(function () { return updateAlpMarker(state.alp); })
              .then(function () { window.location.href = '/cart'; })
              .catch(function () { window.location.href = '/cart'; });
          }, 900);
        })();
      })();
    }

    var sectionEl = root.closest('.shopify-section') || document.body;

    function parentItemFromForm(fd, variantId, parentQty) {
      var parentItem = { id: variantId, quantity: parentQty };
      var sp = fd.get('selling_plan');
      if (sp) parentItem.selling_plan = sp;
      var props = {};
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = v;
      });
      if (Object.keys(props).length) parentItem.properties = props;
      return parentItem;
    }

    // Popup di scelta (atc-choice-popup.js): intercetta lui il submit, prima del
    // popup garanzia, e chiede qui il contesto. Il blocco in scheda resta e da' lo
    // stato di partenza; la conferma finale e' nel popup.
    window.__svcSelector = {
      section: sectionEl,
      contextFor: function (form) {
        var fd = new FormData(form);
        var variantId = fd.get('id');
        if (!variantId) return null;
        var parentQty = parseInt(fd.get('quantity'), 10);
        if (!isFinite(parentQty) || parentQty < 1) parentQty = 1;
        return {
          parentItem: parentItemFromForm(fd, variantId, parentQty),
          qty: parentQty,
          productGid: productGid,
          alp: alp,
          shippingList: data.shippingList || [],
          zip: data.zip || '',
          instIdx: instIdx,
          kcIdx: kcIdx,
          state: { alp: state.alp, addons: Object.assign({}, state.addons) },
          serviceItems: function (alpOn, addonsOn) { return selectedServiceItems(parentQty, alpOn, addonsOn); },
          updateAlpMarker: updateAlpMarker,
          fetch: svcFetch
        };
      }
    };

    // intercetta SOLO i form ATC della sezione prodotto (form principale + sticky bar),
    // NON i quick-add dei prodotti correlati fuori sezione
    var svcSubmitting = false;
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('form[action*="/cart/add"]') : null;
      if (!form || !sectionEl.contains(form) || svcSubmitting) return;

      // riga padre fedele al form: quantity, selling_plan, properties[...]
      var fd = new FormData(form);
      var variantId = fd.get('id');
      var parentQty = parseInt(fd.get('quantity'), 10);
      if (!isFinite(parentQty) || parentQty < 1) parentQty = 1;

      var parentItem = parentItemFromForm(fd, variantId, parentQty);

      var items = selectedServiceItems(parentQty);
      if (!items.length) {
        // flusso normale del tema; aggiorno solo il marcatore al piano in background
        updateAlpMarker(state.alp);
        return;
      }
      if (e.defaultPrevented) {
        // il popup garanzia ha intercettato il submit: mi accodo alla sua chiusura
        proceedAfterWarranty(items);
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      svcSubmitting = true;

      var payload = { items: (variantId ? [parentItem] : []).concat(items) };
      svcFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function () { return updateAlpMarker(state.alp); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { svcSubmitting = false; if (variantId) form.submit(); });
    }, true);

    // totale
    var total = document.createElement('div');
    total.className = 'svc-selector__total';
    total.innerHTML = '<span>Consegna al piano + servizi</span><b data-svc-total></b>';
    wrap.appendChild(total);
    var totalEl = total.querySelector('[data-svc-total]');
    function updateTotal() {
      var sum = 0;
      if (state.alp && alp.price) sum += alp.price;
      if (state.alp) alp.addons.forEach(function (a, i) { if (state.addons[i]) sum += a.price; });
      totalEl.textContent = sum > 0 ? fmtEuro(sum) : '—';
    }
    updateTotal();

    // note
    if (data.notes.length) {
      var note = document.createElement('p');
      note.className = 'svc-selector__note';
      note.innerHTML = data.notes.join('<br>');
      wrap.appendChild(note);
    }

    // alternative di consegna
    altEl = document.createElement('p');
    altEl.className = 'svc-alt';
    wrap.appendChild(altEl);
    updateAlts();

    contentEl.innerHTML = '';
    contentEl.appendChild(wrap);
    contentEl.hidden = false;
    if (loadingEl) loadingEl.remove();
    root.removeAttribute('hidden');
  }

  function svcEndpoint(zip) {
    return apiUrl + '?type=' + encodeURIComponent('product_shipping_info_box') +
      '&product_id=' + encodeURIComponent(productGid) +
      '&logged_in_customer_id=' + encodeURIComponent(customerGid) +
      (zip ? '&zipCode=' + encodeURIComponent(zip) : '');
  }
  function fetchSvc(zip) {
    return fetch(svcEndpoint(zip), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
      .then(function (r) { return r.json(); });
  }

  function run() {
    if (!apiUrl || !productGid) { hide(); return; }
    // zona iniziale: scelta esplicita salvata > CAP dell'indirizzo del cliente loggato
    // senza zona: CAP di Paderno Dugnano, ma il testo resta "indicativo per Milano"
    var savedZip = getCap();
    var chosenZip = savedZip || customerZip;
    var indicative = !chosenZip;
    var zip = chosenZip || DEFAULT_MILAN_ZIP;
    fetchSvc(zip)
      .then(function (d) {
        // paracadute: se la chiamata con zip torna vuota, riprovo senza (prezzo indicativo)
        if ((!d || !d.html || String(d.html).trim() === '') && zip) { zip = ''; return fetchSvc(''); }
        return d;
      })
      .then(function (d) {
        if (!d || !d.html || String(d.html).trim() === '') { hide(); return; }
        if (indicative) d.inputZipCode = '';
        var data = parse(d.html);
        if (!data) { hide(); return; }
        data = applyStructured(data, d);
        if (data.alp.price == null) { hide(); return; }
        data.zipFromAccount = !!(!savedZip && customerZip && data.zip === customerZip);
        render(data);
        done();
      })
      .catch(function (e) { console.error('[services-selector]', e); hide(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
